import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'La collezione completa in 6 volumi + 5 bonus per insegnare la gestione ambientale in modo chiaro, visivo e pronto per la classe.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="sky-backdrop min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nur8c681cizz">
      <MetaPixel data-id="element-1" data-mp="ssss6tdacmci" />
      <main data-id="element-2" data-mp="swglpsiqd8r8">
        <Hero data-id="element-3" data-mp="3685nh1tcguh" />
        <LookInsideCarousel data-id="element-4" data-mp="35yn2ej3lbyt" />
        <ProblemSection data-id="element-5" data-mp="356wxj89s6fx" />
        <SystemSection data-id="element-6" data-mp="38kw6ilmzzj5" />
        <ModulesSection data-id="element-7" data-mp="3ud1glcmeruc7" />
        <BonusSection data-id="element-8" data-mp="3udkqq75thefo" />
        <UrgencySection data-id="element-9" data-mp="3uc9j1w993mja" />
        <PricingSection data-id="element-10" data-mp="3uf5ijp0qyj9u" />
        <GuaranteeSection data-id="element-11" data-mp="d4e94339pv1g" />
        <FAQ data-id="element-12" data-mp="d3mm3gnql5ms" />
        <ClosingSection data-id="element-13" data-mp="d45sq17xs7li" />
        <SummaryTable data-id="element-14" data-mp="d2bibguajxvo" />
        <FinalCta data-id="element-15" data-mp="85ujnspgu14c" />
      </main>
      <Footer data-id="element-16" data-mp="86mc4unrniqe" />
      <PurchaseNotification data-id="element-17" data-mp="8648ve2os48z" />
    </div>;
}